import React from 'react';
import { BsGlobe } from 'react-icons/bs';

import BaseEditWidget from '../BaseEditWidget';
import '../../EditWidget/EditWidget.scss';

const EditWebsites = (props: any) => {
	return (
		<BaseEditWidget
			{...props}
			defaultIcon={{
				name: 'BsGlobe',
				label: 'globe',
				component: BsGlobe,
			}}
			defaultTheme="blue"
			widgetType="websites"
		/>
	);
};

export default EditWebsites;
